import React, { FunctionComponent } from 'react'

import envelopeFlying from '../../assets/lottie/envelope-flying.json'
import { useAnimateLottie } from '../../hooks/useAnimateLottie'

export interface FlyingEnvelopeLottieProps {
  size?: number
  loop?: boolean
}

export const FlyingEnvelopeLottie: FunctionComponent<FlyingEnvelopeLottieProps> = ({ size = 158, loop = true }) => {
  const { AnimationView } = useAnimateLottie(900)

  return <AnimationView source={envelopeFlying} loop={loop} autoPlay={true} style={{ height: size, width: size }} />
}
